import React, { useRef, createContext, useState, useEffect } from 'react';
import {
  Box,
  useTheme,
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@material-ui/core';
import { history } from 'umi';
import ReplyIcon from '@material-ui/icons/Reply';
import CloseIcon from '@material-ui/icons/Close';
import DoneIcon from '@material-ui/icons/Done';
import { useSelector, useDispatch } from 'dva';
import StepsML from './components/StepsML';
import StepsOneML from './components/StepsOneML/StepsOneML';
import StepsTwoML from './components/StepsTwoML/StepsTwoML';
import StepsThreeML from './components/StepsThreeML/StepsThreeML';
import StepsFourML from './components/StepsFourML/StepsFourML';
import Loading from '@/components/LoadingML/LoadingML';
import AddActivityStyled from './AddActivityStyled';
import { createOid } from '@/utils/eventtracing';

const guid = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export const Context = createContext({});

// eslint-disable-next-line no-unused-vars
let bType = null;
export default () => {
  const id = history.location?.query?.id;
  const queryType = history.location?.query?.opt;
  const prizesObj = () => {
    return {
      luckyDrawId: '', // 抽奖活动id
      picUrl: '', //奖品图片
      prizeAmount: '', //奖品价值
      prizeBackColor: '', // 奖品背景颜色
      prizeDescription: '', //奖品说明
      prizeGoods: '', //关联商品信息id
      prizeLevel: '', //奖品等级
      prizeNum: '', // 奖品数量
      prizeSort: null, //奖品展示顺序
      prizeTitle: '', // 奖品标题
      prizeType: 'PHYSICAL', //奖品类型
      probability: [], //概率
      sendType: 'ONLINE', //发放方式
      id: guid(),
      title: '',
      pageNum: 1,
      pageSize: 10,
      category: '',
      type: '',
      chooseIds: [],
      isLastPrize: false,
      picUrlImgs: [],
    };
  };
  const theme = useTheme();
  const saveRef = useRef();
  const childRef = useRef();
  const childRefTwo = useRef();
  const childRefThree = useRef();
  const childRefFour = useRef();
  const dispatch = useDispatch();

  const [formIds, setFormIds] = useState([]);
  const [checkFormIds, setCheckFormIds] = useState([]);
  const {
    companyList, //公司
    giftList,
    giftTotal,
    queryLevelsList,
  } = useSelector((state) => state.addActivity);
  let {
    storeName,
    storeCode,
    storeStatus,
    storeType,
    storesPageNum,
    storesPageSize,
  } = useSelector((state) => state.couponsSetting);
  const [step, setStep] = useState(0);
  // eslint-disable-next-line no-unused-vars
  const [defaultValues, setDefaultValues] = useState({
    activityId: '', //场景营销id
    title: '', //活动名称
    date: { startDate: null, endDate: null },
    dateBeginTimestamp: null, //活动开始日期
    dateEndTimestamp: null, //活动结束日期
    luckyType: 'LUCKY_DRAW', // 活动玩法
    description: '', //活动详情
    isMember: '0', // 是否会员限制 0-不限 1-仅会员
    isMemberNumShow: '0', //参数人数展示 0-隐藏 1-展示
    isMemberNumLimit: '1', //参与人数限制radius 1不限制  0 限制
    memberNumLimit: '', //参与人数限制
    isAllCompany: '0', // 0全部公司true 1指定公司false
    isAllStore: '0', // 0全部门店true 1指定门店false
    stores: [], //可用门店列表
    useStory: false,
    isRotation: '1', //轮播开启 0-关闭 1-开启
    isPoint: false, //消耗x积分可获得x次抽奖 0-不生效 1-生效
    isPurchase: false, //单次购买x元商品可获得x次抽奖 0-不生效 1-生效
    isShare: false, //分享x次活动可获得x次抽奖 0-不生效 1-生效
    isShareMember: false, //分享后需注册为会员才能获得额外x次 0-不生效 1-生效
    content: '', //活动及兑换说明
    phone: '', //客服电话
    prizesList: [], //奖品信息
    companies: [],
    backgroundPic: '', //背景图片
    wheelPic: '', //转盘图片
    wheelBackgroundPic: '', //转盘背景图片
    prizeFontSize: 14,
    prizeFontColor: '#000',
    prizeFont: {
      color: '',
      fontSize: '',
    },
    activityFont: {
      color: '',
      fontSize: '',
    },
    drawNumFont: {
      color: '',
      fontSize: '',
    },
    rotationFont: {
      color: '',
      fontSize: '',
    },
    activityFontSize: 14,
    activityFontColor: '#000',
    drawNumSize: 14,
    drawNumColor: '#000',
    rotationFontSize: 14,
    rotationFontColor: '#000',
    miniprogramNotice: '1', //小程序服务通知 0-关闭 1-开启
    noticeChannels: [], //通知渠道列表
    mChecked: false,
    mType: '', //渠道类型
    mContent: '',
    wChecked: false,
    wType: '',
    wContent: '',
    noticeType: 'NOTICE_ONE', // 通知规则 NOTICE_ONE-仅通知一个渠道 NOTICE_ALL-全渠道通知
    type: 'LUCKY_DRAW_ACTIVITY',
  });
  const [open, setOpen] = useState(false);
  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['addActivity/postFormDetail'];
  //   childRef.current.clickInput();

  const onSubmitSuccess = (data) => {
    console.log('data', data);
    if (step === 0) {
      data.stores = data.useStory ? data.stores : [];
      data.dateBeginTimestamp = data.date.startDate.includes('00:00:00')
        ? data.date.startDate
        : `${data.date.startDate} 00:00:00`;
      data.dateEndTimestamp = data.date.endDate.includes('23:59:59')
        ? data.date.endDate
        : `${data.date.endDate} 23:59:59`;
      setDefaultValues({ ...defaultValues, ...data });
    } else if (step === 1) {
      if (data.prizesList) {
        data.prizesList.forEach((item) => {
          if (
            item.picUrl &&
            (item.picUrl.indexOf('http') > -1 ||
              item.picUrl.indexOf('https') > -1)
          ) {
            const imgUrl = item.picUrl ? item.picUrl.split('/') : [];
            item.picUrl = `${imgUrl[imgUrl.length - 2]}/${
              imgUrl[imgUrl.length - 1]
            }`;
          }
        });
      }
      data.prizeFont = {
        color: data.prizeFontColor,
        fontSize: data.prizeFontSize,
      };
      setDefaultValues({ ...defaultValues, ...data });
    } else if (step === 2) {
      if (
        data.backgroundPic &&
        (data.backgroundPic.indexOf('http') > -1 ||
          data.backgroundPic.indexOf('https') > -1)
      ) {
        const imgUrl = data.backgroundPic ? data.backgroundPic.split('/') : [];
        data.backgroundPic = `${imgUrl[imgUrl.length - 2]}/${
          imgUrl[imgUrl.length - 1]
        }`;
      }
      if (
        data.wheelPic &&
        (data.wheelPic.indexOf('http') > -1 ||
          data.wheelPic.indexOf('https') > -1)
      ) {
        const imgUrl = data.wheelPic ? data.wheelPic.split('/') : [];
        data.wheelPic = `${imgUrl[imgUrl.length - 2]}/${
          imgUrl[imgUrl.length - 1]
        }`;
      }
      if (
        data.wheelBackgroundPic &&
        (data.wheelBackgroundPic.indexOf('http') > -1 ||
          data.wheelBackgroundPic.indexOf('https') > -1)
      ) {
        const imgUrl = data.wheelBackgroundPic
          ? data.wheelBackgroundPic.split('/')
          : [];
        data.wheelBackgroundPic = `${imgUrl[imgUrl.length - 2]}/${
          imgUrl[imgUrl.length - 1]
        }`;
      }
      data.activityFont = {
        color: data.activityFontColor,
        fontSize: data.activityFontSize,
      };
      data.drawNumFont = {
        color: data.drawNumColor,
        fontSize: data.drawNumSize,
      };
      data.rotationFont = {
        color: data.rotationFontColor,
        fontSize: data.rotationFontSize,
      };
      setDefaultValues({ ...defaultValues, ...data });
    } else if (step === 3) {
      let noticeChannels = [];
      if (data.mChecked) {
        //短信
        noticeChannels.push({
          type: 1,
          msgId: data.mType,
          msgContent: data.mContent,
        });
      }
      if (data.wChecked) {
        //短信
        noticeChannels.push({
          type: 2,
          msgId: data.wType,
          msgContent: data.wContent,
        });
      }
      data.noticeChannels = noticeChannels;
      let noticePriority;
      data.noticeType === 'NOTICE_ALL'
        ? (noticePriority = [
            {
              sortNo: 2,
              noticeMsgId: '',
              noticeChannelName: '微信模板消息',
              noticeChannelType: '2',
            },
            {
              sortNo: 1,
              noticeMsgId: '',
              noticeChannelName: '短信',
              noticeChannelType: '1',
            },
          ])
        : (noticePriority = []);
      data.noticePriority = noticePriority;
      setDefaultValues({ ...defaultValues, ...data });
    }
    let newStep = step;
    if (bType === 1) {
      setStep(--newStep);
      return false;
    }
    if (newStep < 4) {
      setStep(++newStep);
    } else {
      setStep(4);
    }
    if (newStep === 4) {
      const postData = JSON.parse(
        JSON.stringify({ ...defaultValues, ...data }),
      );
      delete postData.date;
      delete postData.drawNumColor;
      delete postData.drawNumSize;

      delete postData.mChecked;
      delete postData.mContent;
      delete postData.mType;
      delete postData.prizeFontColor;
      delete postData.prizeFontSize;
      delete postData.rotationFontColor;
      delete postData.rotationFontSize;
      delete postData.useStory;
      delete postData.wChecked;
      delete postData.wContent;
      delete postData.wType;
      const numberTypes = [
        'activityId',
        'allDrawNum',
        'dailyDrawNum',
        'defaultNum',
        'defaultNum',
        'isAllCompany',
        'isAllStore',
        'isMember',
        'isMemberNumLimit',
        'isMemberNumShow',
        // 'isPoint',
        // 'isPurchase',
        'isRotation',
        // 'isShare',
        // 'isShareMember',
        // 'memberDrawNum',
        'memberNumLimit',
        'miniprogramNotice',
        'pointDrawNum',
        'pointNum',
        'purchase',
        'purchaseDrawNum',
        'shareDrawNum',
        'shareNum',
        'shareNum',
        'winNum',
        'prizeAmount',
        'prizeNum',
      ];
      for (let v in postData) {
        if (v === 'prizesList') {
          postData.prizesList.forEach((item) => {
            item.prizeGoods =
              item.chooseIds.length > 0 ? item.chooseIds[0].id : '';
            delete item.category;
            delete item.chooseIds;
            delete item.id;
            delete item.pageNum;
            delete item.pageSize;
            delete item.title;
            delete item.type;
            delete item.picUrlImgs;
            for (let x in item) {
              if (numberTypes.indexOf(x) > -1) {
                item[x] =
                  item[x] || item[x] === 0 || item[x] === '0'
                    ? Number(Number(item[x]).toFixed(2))
                    : null;
              }
            }
          });
        } else if (numberTypes.indexOf(v) > -1) {
          postData[v] = postData[v] ? Number(postData[v]) : null;
        }
      }
      const oldPrizesList = [...postData.prizesList];
      const newPrizesList = oldPrizesList.filter((item) => {
        return item.picUrl;
      });
      postData.prizesList = newPrizesList;
      window.NE_DAWN.trigger(saveRef.current, {
        event: '_ec', // 事件名
        params: { ...postData }, // 事件公参
      });
      let type = id
        ? 'addActivity/postFormDataUpdate'
        : 'addActivity/postFormData';
      dispatch({
        type,
        payload: {
          value: postData,
        },
        callback: () => {
          history.goBack();
        },
      });
    }
  };

  const settingHandleNextClick = (type) => {
    bType = type;
    step === 0 && childRef.current.clickInput();
    step === 1 && childRefTwo.current.clickInput();
    step === 2 && childRefThree.current.clickInput();
    step === 3 && childRefFour.current.clickInput();
  };

  useEffect(() => {}, []);

  useEffect(() => {
    dispatch({
      type: 'addActivity/getCompany',
      payload: {},
    });
  }, [dispatch]);
  // 获取门店列表
  useEffect(() => {
    dispatch({
      type: 'couponsSetting/getStores',
      payload: {
        value: {
          name: storeName,
          code: storeCode,
          status: storeStatus,
          type: storeType,
          pageNum: storesPageNum,
          pageSize: storesPageSize,
          sort: null,
        },
      },
    });
  }, [
    dispatch,
    storeName,
    storesPageNum,
    storesPageSize,
    storeCode,
    storeStatus,
    storeType,
  ]);

  // 微信模板消息
  useEffect(() => {
    dispatch({
      type: 'sceneMarketing/getSmsTemplateList',
      payload: {},
    });
  }, [dispatch]);
  useEffect(() => {
    dispatch({
      type: 'sceneMarketing/getWechatTemplateList',
      payload: {
        values: {
          type: 'FESTIVAL',
        },
      },
    });
  }, [dispatch]);

  //会员等级
  useEffect(() => {
    (async () => {
      if (id) {
        await dispatch({
          type: 'addActivity/postFormDetail',
          payload: {
            values: {
              id,
            },
          },
          callback: (response) => {
            response.date = {
              startDate: response.dateBeginTimestamp,
              endDate: response.dateEndTimestamp,
            };
            response.isMember = response.isMember ? '1' : '0';
            response.isMemberNumShow = response.isMemberNumShow ? '1' : '0';
            response.isMemberNumLimit = response.isMemberNumLimit ? '1' : '0';
            response.memberNumLimit = response.memberNumLimit
              ? response.memberNumLimit
              : null;
            response.isRotation = response.isRotation ? '1' : '0';
            response.miniprogramNotice = response.miniprogramNotice ? '1' : '0';
            response.isAllCompany = response.isAllCompany ? '1' : '0';
            response.isAllStore = String(response.isAllStore);
            response.useStory = response.stores.length > 0;
            response.prizeFontSize = response.prizeFont.fontSize;
            response.prizeFontColor = response.prizeFont.color;
            response.activityFontSize = response.activityFont.fontSize;
            response.activityFontColor = response.activityFont.color;
            response.drawNumSize = response.drawNumFont.fontSize;
            response.drawNumColor = response.drawNumFont.color;
            response.rotationFontSize = response.rotationFont.fontSize;
            response.rotationFontColor = response.rotationFont.color;
            const prizesListDetail = response.prizesList;
            const noticeChannelsDetail = response.noticeChannels;
            if (noticeChannelsDetail.length > 0) {
              noticeChannelsDetail.forEach((item) => {
                if (item.type === '1') {
                  response.mChecked = true;
                  response.mType = item.msgId; //渠道类型
                  response.mContent = item.msgContent;
                } else {
                  response.wChecked = true;
                  response.wType = item.msgId; //渠道类型
                  response.wContent = item.msgContent;
                }
              });
            }
            let pId = [];
            prizesListDetail.forEach((item) => {
              item.id = guid();
              pId.push(item.id);
            });
            const newResponse = { ...response };
            setDefaultValues(newResponse);
            setFormIds(pId);
            setCheckFormIds(pId);
          },
        });
      }
      await dispatch({
        type: 'addActivity/getQueryLevels',
        payload: {},
      });
    })();
  }, [dispatch]);

  const handleClose = () => {
    setOpen(false);
  };

  const handleCloseSure = () => {
    setOpen(false);
    history.goBack();
  };
  return (
    <AddActivityStyled theme={theme}>
      <Box
        data-log={JSON.stringify({
          oid: createOid(),
          isPage: true,
          params: {
            initUrl: window.location.origin + window.location.pathname,
          },
          events: ['_pv', '_pd'],
        })}
        height="100%"
      >
        <Box borderRadius="4px" bgcolor="background.paper" p={4}>
          <StepsML activeStep={step} />
          <Loading loading={loading}>
            <Box display={step === 0 ? 'block' : 'none'}>
              <Context.Provider
                value={{
                  ref: childRef,
                }}
              >
                <StepsOneML
                  onSubmitSuccess={onSubmitSuccess}
                  defaultValues={defaultValues}
                  companyList={companyList}
                  storeName={storeName}
                  queryType={queryType}
                />
              </Context.Provider>
            </Box>
            <Box display={step === 1 ? 'block' : 'none'}>
              <Context.Provider
                value={{
                  ref: childRefTwo,
                }}
              >
                <StepsTwoML
                  onSubmitSuccess={onSubmitSuccess}
                  defaultValues={defaultValues}
                  prizesObj={prizesObj}
                  formIds={formIds}
                  setFormIds={setFormIds}
                  checkFormIds={checkFormIds}
                  setCheckFormIds={setCheckFormIds}
                  giftList={giftList}
                  giftTotal={giftTotal}
                  queryType={queryType}
                  queryLevelsList={queryLevelsList}
                  pageId={id}
                />
              </Context.Provider>
            </Box>
            <Box display={step === 2 ? 'block' : 'none'}>
              <Context.Provider
                value={{
                  ref: childRefThree,
                }}
              >
                <StepsThreeML
                  onSubmitSuccess={onSubmitSuccess}
                  defaultValues={defaultValues}
                  queryType={queryType}
                />
              </Context.Provider>
            </Box>
            <Box display={step >= 3 ? 'block' : 'none'}>
              <Context.Provider
                value={{
                  ref: childRefFour,
                }}
              >
                <StepsFourML
                  onSubmitSuccess={onSubmitSuccess}
                  defaultValues={defaultValues}
                  queryType={queryType}
                />
              </Context.Provider>
            </Box>
            <Box display="flex" gap="0 4px" className="coupon-button-wrap">
              {step !== 0 && (
                <Button
                  color="secondary"
                  variant="contained"
                  className="coupons-setting-button"
                  onClick={() => settingHandleNextClick(1)}
                  title="Submit"
                  startIcon={
                    <ReplyIcon sx={{ width: '16px', height: '16px' }} />
                  }
                >
                  上一步
                </Button>
              )}
              {step < 3 ? (
                <Button
                  variant="contained"
                  className="coupons-setting-button"
                  onClick={() => settingHandleNextClick(2)}
                  title="Submit"
                  startIcon={
                    <ReplyIcon
                      sx={{ width: '16px', height: '16px' }}
                      className="next-button-icon"
                    />
                  }
                >
                  下一步
                </Button>
              ) : (
                queryType !== 'detail' && (
                  <Button
                    ref={saveRef}
                    variant="contained"
                    className="coupons-setting-button"
                    onClick={() => settingHandleNextClick(2)}
                    startIcon={
                      <DoneIcon sx={{ width: '16px', height: '16px' }} />
                    }
                  >
                    完成
                  </Button>
                )
              )}
              <Button
                variant="contained"
                className="coupons-setting-button"
                color="secondary"
                onClick={() => setOpen(true)}
                startIcon={<CloseIcon sx={{ width: '16px', height: '16px' }} />}
              >
                退出
              </Button>
            </Box>
          </Loading>
        </Box>
      </Box>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            sx={{ minWidth: '200px' }}
          >
            {queryType !== 'detail'
              ? '退出后将不保存设置内容，确定要退出吗？'
              : '确定要退出吗？'}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="text"
            sx={{ color: '#999', width: '57px' }}
            onClick={handleClose}
          >
            取消
          </Button>
          <Button
            variant="text"
            sx={{ width: '57px' }}
            onClick={handleCloseSure}
            autoFocus
          >
            确定
          </Button>
        </DialogActions>
      </Dialog>
    </AddActivityStyled>
  );
};
